import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../../assets/data/data.json';
import './MyLottie.css';

const MyLottie = ({ className = '' }) => {
  return (
    <div className={`lottie-wrapper ${className}`}>
      <Lottie animationData={animationData} loop={true} autoplay={true} />
    </div>
  );
};

export default MyLottie;
